'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 37 28',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'defs',
                null,
                _react2.default.createElement(
                    'linearGradient',
                    {
                        id: 'productVisaWhite_svg__a',
                        x1: '10.314%',
                        x2: '93.063%',
                        y1: '54.603%',
                        y2: '45.005%'
                    },
                    _react2.default.createElement('stop', { offset: '0%', stopColor: '#1A1D59' }),
                    _react2.default.createElement('stop', { offset: '100%', stopColor: '#112D97' })
                )
            ),
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M0 3h37v22H0z', fill: props.fill, fillRule: 'nonzero' }),
                _react2.default.createElement('path', {
                    d: 'M16.548 3.197c-.016 1.393 1.284 2.17 2.264 2.632 1.008.474 1.346.779 1.342 1.203-.007.648-.804.935-1.548.946-1.3.02-2.054-.34-2.655-.61l-.469 2.118c.604.268 1.72.502 2.876.514 2.716 0 4.493-1.298 4.501-3.31.012-2.552-3.647-2.693-3.622-3.833.008-.347.35-.716 1.096-.81.371-.047 1.392-.083 2.55.433l.454-2.051A7.159 7.159 0 0 0 20.918 0c-2.556 0-4.355 1.314-4.37 3.197zM27.705.177c-.496 0-.915.28-1.1.71l-3.88 8.962h2.715l.539-1.444h3.317l.312 1.444H32L29.912.177h-2.207zm.38 2.613l.782 3.632h-2.143l1.36-3.632zM13.26.177l-2.14 9.672h2.586L15.844.177H13.26zm-3.827 0L6.743 6.76l-1.09-5.597A1.195 1.195 0 0 0 4.462.177H.06L0 .457c.902.19 1.93.496 2.55.823.381.2.49.374.615.85l2.062 7.72H7.96L12.15.176H9.433z',
                    fill: 'url(#productVisaWhite_svg__a)',
                    transform: 'translate(2 9)'
                })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#FFF',
    width: '37px',
    height: '28px'
};

Icon.displayName = 'ProductVisaWhite';

exports.default = Icon;